import { Layout } from "../../../layouts/v1";
import { MainView } from "../../../views/return-exchange/download-form";
import { ReturnExchangeDownloadFormsContextProvider } from "../../../views/return-exchange/download-form/contexts/ReturnExchangeDownloadFormsContext";

export function ReturnExchange_DownloadFormPage(props) {
    return (
        <>
            <ReturnExchangeDownloadFormsContextProvider>
                <Layout>
                    <MainView />
                </Layout>
            </ReturnExchangeDownloadFormsContextProvider>
        </>
    );
}